// src/auth.js

export const login = () => {
  const domain = process.env.REACT_APP_COGNITO_DOMAIN;
  const clientId = process.env.REACT_APP_CLIENT_ID;
  const redirectUri = process.env.REACT_APP_REDIRECT_URI;

  // Set session marker to indicate intentional login
  sessionStorage.setItem("cognito_session", "active");
  
  // Simple login without forcing fresh authentication to avoid challenge transitions
  const loginUrl = `https://${domain}/login?client_id=${clientId}&response_type=token&scope=email+openid+profile&redirect_uri=${encodeURIComponent(redirectUri)}`;
  window.location.href = loginUrl;
};

export const logout = () => {
  const domain = process.env.REACT_APP_COGNITO_DOMAIN;
  const clientId = process.env.REACT_APP_CLIENT_ID;
  const redirectUri = process.env.REACT_APP_REDIRECT_URI;

  // Clear all stored authentication data
  localStorage.removeItem("username");
  sessionStorage.removeItem("cognito_session");

  // Simple logout without aggressive cookie clearing
  const logoutUrl = `https://${domain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(redirectUri)}`;
  window.location.href = logoutUrl;
};

// Force fresh login - used for shared URLs (simplified approach)
export const forceFreshLogin = () => {
  const domain = process.env.REACT_APP_COGNITO_DOMAIN;
  const clientId = process.env.REACT_APP_CLIENT_ID;
  const redirectUri = process.env.REACT_APP_REDIRECT_URI;

  // Clear local storage only
  localStorage.removeItem("username");
  sessionStorage.removeItem("cognito_session");
  
  // Force logout first to clear Cognito session, then redirect to login
  const logoutUrl = `https://${domain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(redirectUri)}`;
  window.location.href = logoutUrl;
};


export const getUserFromToken = () => {
  const hash = window.location.hash.substring(1);
  const params = new URLSearchParams(hash);
  const idToken = params.get("id_token");

  if (idToken) {
    try {
      const payload = JSON.parse(atob(idToken.split(".")[1]));
      const username = payload.email || payload["cognito:username"];
      
      // Check if token is expired
      const currentTime = Math.floor(Date.now() / 1000);
      if (payload.exp && payload.exp < currentTime) {
        // Token is expired, clear localStorage and return null
        localStorage.removeItem("username");
        return null;
      }
      
      localStorage.setItem("username", username);
      return payload;
    } catch (error) {
      // Invalid token format, clear localStorage
      localStorage.removeItem("username");
      return null;
    }
  }

  // If no token in URL, check stored session validity
  const storedUsername = localStorage.getItem("username");
  const hasValidSession = sessionStorage.getItem("cognito_session");
  
  // Only return user if both stored username AND valid session exist
  if (storedUsername && hasValidSession) {
    return { email: storedUsername };
  }

  // Clear any stale data
  localStorage.removeItem("username");
  return null;
};
